export default function LoadingSpinner({ className }: { className?: string }) {
    return (
        <svg
            width="30px"
            height="30px"
            className={`
                animate-spin

                ${className}
            `}
            viewBox="0 0 16 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                fill="currentColor"
                d="M15 8c0 3.9-3.1 7-7 7s-7-3-7-7h-1c0 4 3.6 8 8 8s8-3.6 8-8h-1z"
            ></path>
        </svg>
    )
}
